// extracted by mini-css-extract-plugin
module.exports = {"text":"copyright_text__wY1GU","heart":"copyright_heart__1hh28"};